import type { OrderQueue } from '@elutide/shared';

export interface QueueRailProps {
  queues: readonly { id: OrderQueue; label: string; count: number }[];
  active: OrderQueue;
  onSelect: (queue: OrderQueue) => void;
}

/**
 * Left rail on desktop, chip row on a phone. The counts come from `/orders/queues`, which
 * reads the same `queue_count` metric the list reads, so the rail and the list cannot
 * disagree. Nothing here recomputes a count.
 */
export function QueueRail({ queues, active, onSelect }: QueueRailProps) {
  return (
    <nav className="o-rail" aria-label="Order queues" data-allow-hscroll="true">
      {queues.map((queue, index) => (
        <button
          key={queue.id}
          type="button"
          className="o-chip"
          aria-pressed={queue.id === active}
          onClick={() => onSelect(queue.id)}
          accessKey={index < 9 ? String(index + 1) : undefined}
        >
          <span>{queue.label}</span>
          <span className="o-chip__count">{queue.count}</span>
        </button>
      ))}
    </nav>
  );
}
